/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Expense_Sync_Transacted_AtInputs */

const vi_expense_sync_transacted_at = /** @type {(inputs: Expense_Sync_Transacted_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thời điểm`)
};

/**

* @param {Expense_Sync_Transacted_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const expense_sync_transacted_at = /** @type {((inputs?: Expense_Sync_Transacted_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Expense_Sync_Transacted_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_expense_sync_transacted_at(inputs)
});